export default __webpack_public_path__ + "static/media/goodreads-logo-s.81e46240.svg";